export default __webpack_public_path__ + "static/media/uploader-dexcom-problem-1.937775ff.png";